var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 11C1 5.47716 5.47716 1 11 1C16.5229 1 21 5.47716 21 11C21 16.5229 16.5229 21 11 21C5.47716 21 1 16.5229 1 11Z",
    stroke: "#1B224C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.66699 7.66699L14.3337 14.3337M14.3337 7.66699L7.66699 14.3337",
    stroke: "#1B224C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close Icon.47b7b54ec16423dfe05d5c8cfae9bd8f.svg";
export { ForwardRef as ReactComponent };